import {
  faCarSide,
  faCoins,
  faGraduationCap,
  faHouse,
  faLandmark,
} from '@fortawesome/pro-solid-svg-icons';

import QuickLinkSection from '../QuickLinkSection';
import { QuickLinkSectionItem } from '../QuickLinkSectionItem';

export const SectionLearnMore = () => (
  <QuickLinkSection title="Learn More">
    <QuickLinkSectionItem
      href="https://engine.tech/developer-center/integrations/api/products/loans/personal"
      icon={faLandmark}
      target="_blank"
      title="Personal Loans"
    />
    <QuickLinkSectionItem
      href="https://engine.tech/developer-center/integrations/api/products/loans/personal"
      icon={faGraduationCap}
      target="_blank"
      title="Student Loan Refinancing"
    />
    <QuickLinkSectionItem
      href="https://engine.tech/developer-center/integrations/api/products/loans/heloc"
      icon={faHouse}
      target="_blank"
      title="HELOC"
    />
    <QuickLinkSectionItem
      href="https://engine.tech/developer-center/integrations/api/products/loans/auto-refinancing"
      icon={faCarSide}
      target="_blank"
      title="Auto Loan Refinancing"
    />
    <QuickLinkSectionItem
      href="https://engine.tech/developer-center/integrations/api/products/savings"
      icon={faCoins}
      target="_blank"
      title="Savings"
    />
    {/* <QuickLinkSectionItem
      href="https://engine.tech/developer-center/reference/life-insurance-reference"
      icon={faUmbrella}
      target="_blank"
      title="Life Insurance"
    /> */}
    {/* <QuickLinkSectionItem
      href="https://engine.tech/developer-center/reference/other-verticals/credit-cards"
      icon={faCreditCard}
      target="_blank"
      title="Credit Cards"
    /> */}
  </QuickLinkSection>
);
